import { combineReducers } from 'redux';

import {
  AFTER_SALES,
  AUDIT,
  DEALERS_ADMINISTRATION,
  DEFAULT,
  SALES,
  APPOINTMENT,
  CHAT,
  PARTS,
} from 'constants/ExtensionConstants';
import { CAR_CONFIGURATOR } from 'constants/FeatureConstants';

import allDealerIdsReducer from './allDealerIdsReducer';
import configDealerIdsReducer from './configDealerIdsReducer';
import configDealerLinksReducer from './configDealerLinksReducer';
import dealersByIdReducer from './dealersByIdReducer';
import administrationDealerIdsReducer from './extensions/administrationDealerIdsReducer';
import afterSalesDealerIdsReducer from './extensions/afterSalesDealerIdsReducer';
import auditDealerIdsReducer from './extensions/auditDealerIdsReducer';
import chatDealerIdsReducer from './extensions/chatDealerIdsReducer';
import partsDealerIdsReducer from './extensions/partsDealerIdsReducer';
import salesDealerIdsReducer from './extensions/salesDealerIdsReducer';
import carConfiguratorDealerIdsReducer from './features/carConfiguratorDealerIdsReducer';
import keyDepositDealerIdsReducer from './features/keyDepositDealerIdsReducer';
import selectedDealerIdReducer from './selectedDealerIdReducer';

/**
 * @typedef {{
 *  allIds: import('./allDealerIdsReducer').State,
 *  byId: import('./dealersByIdReducer').State,
 *  search: string[],
 *  selectedId: string,
 *  links: Record<string, import('modules/global/generic.types').Link>
 * } & Record<Exclude<import('modules/global/typing/enums/extensions.enum').ExtensionEnum, 'APPLE_TV' | 'TRACK'>, string>} DealersEntitiesReducer
 */

export default combineReducers({
  allIds: allDealerIdsReducer,
  byId: dealersByIdReducer,
  selectedId: selectedDealerIdReducer,
  links: configDealerLinksReducer,
  [DEFAULT]: configDealerIdsReducer,
  [AFTER_SALES]: afterSalesDealerIdsReducer,
  [AUDIT]: auditDealerIdsReducer,
  [CAR_CONFIGURATOR]: carConfiguratorDealerIdsReducer,
  [APPOINTMENT]: keyDepositDealerIdsReducer,
  [CHAT]: chatDealerIdsReducer,
  [PARTS]: partsDealerIdsReducer,
  [SALES]: salesDealerIdsReducer,
  [DEALERS_ADMINISTRATION]: administrationDealerIdsReducer,
});
